import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './page/Home.jsx';
import Event from './page/Event.jsx';
import Contact from './page/Contact.jsx';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';
import Onbording from './page/Onbording.jsx';
import Dashboard from './page/Dashboard.jsx';
import Myevents from './page/Myevents.js';
import Myreviews from './page/Myreviews.js';
import RefundPolicy from './page/RefundPolicy.js';
import TermsService from './page/TermsService.js';
import PrivacyPolicy from './page/PrivacyPolicy.js';
import { AdminLayout } from './layout/adminLayout/AdminLayout.jsx';
import Singleeventdetails from './page/Singleeventdetails.jsx';
import { useAuth } from './context/AuthContext';
import Finalticket from './page/Finalticket.jsx';
import Ticket  from './components/Ticket.jsx';
import Successticket from './page/Success.jsx'

import RouteTracker from "./analytics/RouteTracker";

function AppContent() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.includes('admin');
  const { isAuthenticated, user } = useAuth();

  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  const AdminRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/" replace />;
    }
    if (user?.role !== 'admin') {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  return (
    <>
      <RouteTracker /> {/* ✅ ADD: page tracking for GA4 */}
      
      {!isAdminRoute && <Navbar onContactClick={() => setIsContactOpen(true)} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Event />} />
        <Route path="/onbording" element={<Onbording />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path='/Myevents' element={<Myevents />} />
        <Route path='/Myreviews' element={<Myreviews />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path='/TermsService' element={<TermsService />} />
        <Route path='/RefundPolicy' element={<RefundPolicy />} />
        <Route path='/Finalticket' element={<Finalticket />} />
        <Route path='/Finalticket/:orderId' element={<Finalticket />} />
        <Route path='/Ticket' element={<Ticket />} />
        <Route path='/Successticket' element={<Successticket />} />
        <Route path='/Successticket/:orderId' element={<Successticket />} />


        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        />
        <Route path='/Singleeventdetails' element={<Singleeventdetails />} />
        <Route path='/Singleeventdetails/:id' element={<Singleeventdetails />} />
      </Routes>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && (isContactOpen && <Contact onClose={() => setIsContactOpen(false)} />)}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
